import { useState } from "react";
import Button from "./Button";
import DatePicker from "./DatePicker";
import SearchInput from "./SearchInput";

const SearchAndFilterBar = ({
  searchPlaceholder = "Tìm kiếm khách hàng",
  searchValue,
  onSearchChange,
  onSearchClick,
  onSearchKeyDown,
  showDatePickers = false,
  fromDatePlaceholder = "Từ ngày",
  fromDateValue,
  toDatePlaceholder = "Đến ngày",
  toDateValue,
  onFromDateChange,
  onToDateChange,
  onAddClick,
  addButtonLabel = "Thêm",
  addButtonIcon,
  showFilter = true,
  filterLabel = "Bộ lọc",
  filterContent,
  showAdditionBtn = true,
  showSearchInput = true,
}) => {
  const [openPicker, setOpenPicker] = useState(null);

  const handleDatePickerToggle = (picker) => {
    setOpenPicker((prev) => (prev === picker ? null : picker));
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* LEFT GROUP */}
      <div className="flex flex-wrap items-center gap-3">
        {/* Search Input */}
        {showSearchInput && (
          <SearchInput
              value={searchValue}
              placeholder={searchPlaceholder}
              onChange={onSearchChange}
              onKeyDown={onSearchKeyDown}
              onSearch={onSearchClick}
              className="md:w-[400px]"
          />
        )}

        {/* Date Pickers Group */}
        {showDatePickers && (
          <div className="flex items-center gap-3">
            <div className="w-full min-w-[290px] max-w-[290px]">
              <DatePicker
                placeholder={fromDatePlaceholder}
                onChange={onFromDateChange}
                height="42px"
                isCalendarOpen={openPicker === "fromDate"}
                initValue={fromDateValue}
                onToggle={() => handleDatePickerToggle("fromDate")}
              />
            </div>
            <div className="w-full min-w-[290px] max-w-[290px]">
              <DatePicker
                placeholder={toDatePlaceholder}
                onChange={onToDateChange}
                height="42px"
                initValue={toDateValue}
                isCalendarOpen={openPicker === "toDate"}
                onToggle={() => handleDatePickerToggle("toDate")}
              />
            </div>
          </div>
        )}

        {filterContent}

        {/* Filter/Apply Button */}
        {showFilter && (
          <Button
            type="button"
            variant="primary"
            size="lg"
            onClick={onSearchClick}
            aria-label={filterLabel}
          >
            {filterLabel}
          </Button>
        )}
      </div>

      {/* RIGHT GROUP - Add Button */}
      {showAdditionBtn && (
        <Button
          type="button"
          variant="primary"
          size="lg"
          onClick={onAddClick}
          className="ml-auto"
          aria-label={addButtonLabel}
          leftIcon={
            addButtonIcon ? (
              <img src={addButtonIcon} alt="" className="size-4" />
            ) : null
          }
        >
          {addButtonLabel}
        </Button>
      )}
    </div>
  );
};

export default SearchAndFilterBar;
